export const rotatingHeadlines = [
  "The delivery people who make regulated programmes land.",
  "Meeting your deadlines is your reputation.",
  "Senior people on the programmes that can't slip.",
  "Delivery discipline meets financial governance.",
];

export const accreditations = [
  "100% Black-owned",
  "B-BBEE Level 1",
  "Delivering since 2023",
  "Financial-services specialists",
];

export const steps = [
  { n: "01", title: "Understand", text: "The mandate, the deadline and what is truly at stake." },
  { n: "02", title: "Assess", text: "Delivery position, capacity and risk, measured with evidence." },
  { n: "03", title: "Deliver", text: "Run the delivery, stand up the PMO, or place the team — or review it." },
  { n: "04", title: "Evidence", text: "Report in a form boards, audit committees and regulators accept." },
  { n: "05", title: "Sustain", text: "Keep the gains, with early warning of the next slip." },
];

export const whyUs = [
  { label: "Practitioner-led", title: "We have run large regulated programmes", text: "Led by people who deliver payments and change inside major institutions, not career consultants." },
  { label: "Governed", title: "A Chartered Accountant on the board", text: "CA(SA) financial-controls credibility applied to how programmes are delivered, costed and governed." },
  { label: "Evidence", title: "Numbers, not opinion", text: "Proprietary scenario-planning and flow tooling lets us assess delivery risk and capacity with evidence." },
  { label: "Independent", title: "An honest second opinion", text: "When we review rather than deliver, we don't sell the transformation — so the verdict is one a board can rely on." },
];

export const standFor = [
  { title: "Practitioner-led", text: "We have run large regulated programmes ourselves — we deliver, we don't just advise." },
  { title: "Evidence-led", text: "We measure delivery risk and capacity, and report numbers, not opinion." },
  { title: "Governed", text: "Financial governance is built into how we deliver, not added later." },
  { title: "Independent", text: "When we review rather than deliver, we don't sell the transformation — so the verdict can be trusted." },
];

export const trackRecord = [
  {
    org: "Vodacom",
    type: "4-year tenure",
    text: "Stood up six cross-functional scrum teams from scratch and delivered a data-rollover regulatory compliance programme.",
    tags: ["Team build", "Scaled agile", "Compliance"],
    outcome: "88% feature predictability sustained across four years.",
  },
  {
    org: "Nedbank",
    type: "Programme delivery",
    text: "Delivered the omni-channel programme unifying Corporate & Investment Banking and Business Banking.",
    tags: ["Omni-channel", "CIB + Business Banking", "Integration"],
    outcome: "Two divisions unified onto a single channel experience.",
  },
  {
    org: "Standard Bank",
    type: "Current",
    text: "Delivered the Two-Pot retirement reform compliance programme, stood up four scrum teams and a release train, and leads domestic payments transformation.",
    tags: ["Regulatory compliance", "ART launch", "Payments"],
    outcome: "Regulatory deadlines met; delivery scaled from teams to a release train.",
  },
];

export const outcomes = [
  { icon: "CalendarCheck", title: "On-time regulatory delivery", text: "Mandatory programmes that land on their fixed dates, not after them." },
  { icon: "Users", title: "Delivery capacity, fast", text: "Senior PMs, Scrum Masters and PMO people in your teams without lowering the bar." },
  { icon: "ShieldCheck", title: "Lower delivery risk", text: "Capacity, dependencies and cost understood before they bite." },
  { icon: "Scale", title: "An independent verdict", text: "When you need it: a board-ready review of whether a programme will land." },
];

export const edgePoints = [
  { title: "Assurance boards trust.", text: "Co-signed with CA(SA) financial-controls credibility." },
  { title: "Financially-governed delivery.", text: "Business-case integrity, benefits and cost control built in." },
  { title: "A financially-governed PMO.", text: "Investment governance and benefits tracking embedded, not bolted on." },
];

export const industries = [
  { icon: "Landmark", name: "Banking & Financial Services" },
  { icon: "ShieldCheck", name: "Insurance" },
  { icon: "LineChart", name: "Asset Management" },
  { icon: "Radio", name: "Telecommunications" },
  { icon: "CreditCard", name: "Payments & Fintech" },
  { icon: "Building2", name: "Public Sector" },
  { icon: "Factory", name: "Manufacturing & Logistics" },
  { icon: "Sprout", name: "Growing Businesses" },
];

export const insightsPlaceholders = [
  { category: "Regulatory Delivery", title: "Will your ISO 20022 migration land?", summary: "What the November 2026 deadline really asks of a payments programme, and how to know if you'll make it." },
  { category: "Assurance", title: "Where delivery time really goes", summary: "Flow efficiency, and why most programmes spend far more time waiting than working." },
  { category: "Governance", title: "Assurance an audit committee will accept", summary: "Turning delivery status into independent, evidence-based confidence a board can rely on." },
  { category: "FATF & AML", title: "From grey-list exit to measurable outcomes", summary: "What the next FATF evaluation really expects of accountable institutions through 2027." },
  { category: "PMO", title: "A PMO that holds under pressure", summary: "Building financial governance into the office, not bolting it on afterwards." },
  { category: "Ways of Working", title: "SAFe without the theatre", summary: "Making PI Planning and agile ways of working actually move delivery, not just ceremonies." },
];

export const marqueeItems = [
  "Programme Delivery", "PMO & Governance", "Delivery Resourcing",
  "SAFe Training", "Delivery Assurance", "Regulated Change",
];

export const team = [
  {
    initials: "TN",
    name: "Takunda Noha",
    role: "Founder",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_ic-consulting/artifacts/9df7362fceae2f47_Takunda%20Noha.jpeg",
    bio: "A decade of programme and delivery leadership in financial services, currently delivering domestic payments transformation across multiple teams and payment systems. Experience spans Standard Bank, Absa, Nedbank, Vodacom and STANLIB.",
    certs: ["SAFe SPC", "PRINCE2", "Scrum"],
  },
  {
    initials: "TN",
    name: "Thandi Noha",
    role: "Director",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_ic-consulting/artifacts/3e1995f3fe174dee_Thandi%20Noha.jpeg",
    bio: "A Chartered Accountant bringing financial governance, controls and audit-grade rigour to our delivery work — the credibility that lets us speak the language of boards and audit committees.",
    certs: ["CA(SA)"],
  },
];

export const progression = ["Current State", "Identify", "Analyse", "Improve", "Measure", "Optimise", "Better Performance"];
